export const PlatformSalary = 'PlatformSalary';
export const PlatformSalarySummary = PlatformSalary + '/Summary';
